import React, { useEffect, useState } from "react";
import Modal from "react-bootstrap/Modal";
import Button from "react-bootstrap/Button";
import GinScoreHeadImg from "../../assets/Game/GinRummy/images/ModalImg.png";
import "./GinGameScore.css";
import Col from "react-bootstrap/Col";
import Nav from "react-bootstrap/Nav";
import Row from "react-bootstrap/Row";
import Tab from "react-bootstrap/Tab";
import Table from "react-bootstrap/Table";

const GinGameScore = ({ onHide, setTotalBotScore, totalBotScore, totalPlayerScore, setTotalPlayerScore, botResponseFromApi, playerResponseFromApi, ...props }) => {
  console.log("botResponseFromApibotResponseFromApi", totalBotScore , totalPlayerScore)
  const userName = localStorage.getItem("userName")
  const userName2 = localStorage.getItem("userName2")
  console.log("userName2",userName2)
  const closeBtn = () => {
    props.setShowScore(false);
  };

  return (
    <Modal
      {...props}
      // onHide={onHide}
      show={props.showScore}
      size="lg"
      aria-labelledby="GinGameScoreCard"
      centered
    >
      <Modal.Header closeButton onClick={closeBtn}>
        <Modal.Title id="GinGameScoreCard">Score</Modal.Title>
        <img src={GinScoreHeadImg} alt="" />
      </Modal.Header>
      <Modal.Body>
        <Tab.Container id="left-tabs-example" defaultActiveKey="first">
          <Nav variant="pills" className="row px-2 d-flex cstmTabGroup">
            <Nav.Item className="col-6 p-0  text-center">
              <Nav.Link eventKey="first">Score</Nav.Link>
            </Nav.Item>

          </Nav>
          <Row>
            <Col sm={12}>
              <Tab.Content>
                <Tab.Pane eventKey="first">
                  <Table striped bordered hover>
                    <thead>
                      <tr>
                        <th rowSpan={2}>Sr. No.</th>
                        <th rowSpan={2}>Round</th>
                        <th colSpan={2} className="text-center text-capitalize">{userName}</th>
                        <th colSpan={2} className="text-center text-capitalize">{userName2 ? userName2 : "Jarvis"}</th>
                      </tr>
                      <tr>
                        <th>Score</th>
                        <th>Bonus</th>
                        <th>Score</th>
                        <th>Bonus</th>
                      </tr>
                    </thead>
                    <tbody>

                      {botResponseFromApi &&
                        botResponseFromApi &&
                        botResponseFromApi?.map((item2, i) => {
                          return (
                            <>
                              <tr>
                                <td>{i + 1}</td>
                                <td>{item2.round}</td>
                                <td>{playerResponseFromApi[i]?.score}</td>
                                <td>{playerResponseFromApi[i]?.bonusScore}</td>
                                <td>{item2.score}</td>
                                <td>{item2.bonusScore}</td>
                              </tr>
                         
                            </>
                          );
                        })}
                             <tr>
                        <th colSpan={2}>Sub Total</th>
                        <th colSpan={2} className="text-center">{totalPlayerScore}</th>
                        <th colSpan={2} className="text-center">{totalBotScore}</th>
                      </tr>
                        
                    </tbody>
                  </Table>
                </Tab.Pane>
              </Tab.Content>
            </Col>
          </Row>
        </Tab.Container>
      </Modal.Body>
      <Modal.Footer>
        <Button onClick={closeBtn}>Close</Button>
      </Modal.Footer>
    </Modal>
  );
};

export default GinGameScore;
